<template>
  <div>
    <b-checkbox
      v-for="(choice, cIndex) in field.properties.basic.choices"
      :key="cIndex"
      :value="values[field.id] ? values[field.id].split(',') : null"
      class="is-12"
      :class="{
        'column': !field.properties.basic.displayOptionsInRow
      }"
      size="is-small"
      :name="field.id"
      :true-value="choice"
      :native-value="choice"
      @input="handleInput(choice, cIndex)"
      v-on="fieldEvents"
    >
      {{ getTranslation(`${field.id}_choice${cIndex + 1}`, choice) }}
    </b-checkbox>
  </div>
</template>

<script >
import { useLocalizationStore } from '@/store/localizationStore';
const __sfc_main = {};
__sfc_main.props = {
  field: {
    type: Object,
    required: true
  },
  values: {
    type: Object,
    required: true
  },
  errors: {
    type: Object,
    required: true
  },
  fieldEvents: {
    type: Object,
    default: () => ({})
  },
  customEventHandler: {
    type: Function,
    default: () => {}
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const localizationStore = useLocalizationStore();
  const {
    getTranslation
  } = localizationStore;
  const handleInput = (choice, index) => {
    emit('update', {
      value: choice,
      label: getTranslation(`${props.field.id}_choice${index + 1}`, choice)
    });
    if (props.customEventHandler) {
      props.customEventHandler();
    }
  };
  return {
    getTranslation,
    handleInput
  };
};
export default __sfc_main;
</script>
